import React from 'react';
import PropTypes from 'prop-types';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  MobileThreadHeader,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/MobileThreadHeader';
import {
  DesktopThreadHeader,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/DesktopThreadHeader';

const ThreadHeader = ({
  className,
}) => {
  const isMobile = useMobileLayout();

  const ThreadHeaderComponent = isMobile ? MobileThreadHeader : DesktopThreadHeader;

  return (
    <ThreadHeaderComponent className={className} />
  );
};

ThreadHeader.defaultProps = {
  className: '',
};

ThreadHeader.propTypes = {
  className: PropTypes.string,
};

export { ThreadHeader };
